<script lang="ts">
    import { flinkGateway } from "../services";
    import { t } from "@lernetz/svelte-translate";
    import { get, type Writable } from "svelte/store";
    import LastVisitedMaterial from "./LastVisitedMaterial.svelte";
    //import type { Progress } from "@/gateway/models";

    let lastVisited = [];
    flinkGateway.lastVisited().then( response => {
        lastVisited = response;
    }).catch(error => {
        console.error("Error fetching last visited:", error);
        lastVisited = [];
    });

</script>
{#if lastVisited.length != 0}
    <h1 class="text-14 text-almost-black">{$t("last-visited")}</h1>
        <div class="mt-16 grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-16 sm:gap-24 content-center">
        {#each lastVisited as material, index}
            <LastVisitedMaterial  model={material} index={index}></LastVisitedMaterial>
        {/each}
    </div>
{/if}
